import Model, { type HasMany, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { Dayjs } from 'dayjs';
import type { TotalRevenueHotel, TotalRevenueTrendItem } from 'lumen/models';
import { calculateAndAssignCapacity } from 'lumen/utils/total-revenue/calculate-capacity';

export default class TotalRevenueTrend extends Model {
  [Type] = 'total-revenue/trend' as const;

  @hasMany('total-revenue/trend-item', { async: false, inverse: null })
  declare days: HasMany<TotalRevenueTrendItem>;

  @hasMany('total-revenue/trend-item', { async: false, inverse: null })
  declare months: HasMany<TotalRevenueTrendItem>;

  @hasMany('total-revenue/trend-item', { async: false, inverse: null })
  declare weeks: HasMany<TotalRevenueTrendItem>;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get daysSorted() {
    return this.sortTrendItems([...this.days]);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get monthsSorted() {
    return this.sortTrendItems([...this.months]);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get weeksSorted() {
    return this.sortTrendItems([...this.weeks]);
  }

  calculateAndAssignCapacity(
    from: Dayjs,
    to: Dayjs,
    ...allHotels: TotalRevenueHotel[]
  ): void {
    [...this.days, ...this.weeks, ...this.months].forEach((item) => {
      calculateAndAssignCapacity(item, from, to, ...allHotels);
    });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  sortTrendItems(trendItems: TotalRevenueTrendItem[]) {
    return trendItems.sort((a, b) => (a.date.isAfter(b.date) ? 1 : -1));
  }
}
